<template>
	<div class="brandDetail">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span>{{brand.title}}</span>
			<div></div>
		</div>
		<!-- 顶部展示图片 -->
		<img :src="brand.image | handleUrl" alt="">
		<!-- 企业介绍 -->
		<div class="msg">
			<!-- <img :src="brand.brang_icon | handleUrl" alt=""> -->
			<div ref="richText" v-html='brand.content'></div>
		</div>
		<div class="dianhua">
			<van-button type="primary" color="linear-gradient(to right,#ffd01e,#ff8917)" @click="callPhone(brand.tel)">
				<van-icon name="phone" size="1rem" />
				拨打电话</van-button>
			<van-button type="info" color="linear-gradient(to right,#ff6034,#ee0a24)" @click="open53(brand.kefu)">
				<van-icon name="manager" size="1rem" />
				在线客服</van-button>
		</div>
		<van-divider :style="{ color: '#000', borderColor: '#ccc', padding: '0 16px' }">线下体验店</van-divider>
		<!-- 体验店导航 -->
		<div v-if="localList.length == 0"></div>
		<van-tabs swipeable @change="change" v-else v-model="active">
			<van-tab v-for="item in localList.city" :title="item.title" :name="item.id" />
			<div class="none" v-if="localList.experience.length == 0">该城市没有体验店哦~</div>
			<div class="localDetail" v-else v-for="item in localList.experience">
				<span>{{item.title}}</span>
				<div class='localImg'>
					<img v-for="items in item.image" :src="items | handleUrl" alt="">
				</div>
				<div class="localTouch">
					<span>面积: {{item.size}}㎡</span>
					<span>电话: {{item.tel}} ({{item.lxr}})</span>
				</div>
				<span>地址: {{item.address}}&nbsp;<router-link to=""></router-link></span>
			</div>
		</van-tabs>
		<div :class="searchBarFixed==true? 'main active':'main' " id="searchBar">
			<van-divider :style="{ color: '#000', borderColor: '#ccc', padding: '0 16px' }">精品推荐</van-divider>
			<Goods></Goods>
		</div>
	</div>
</template>

<script>
	import Goods from '@/components/goods/goods'

	export default {
		name: 'brandDetail',
		data() {
			return {
				localList: [],
				activeName: ['1'],
				value1: 0,
				brand: [],
				active: 1,
				searchBarFixed: false
			}
		},
		components: {
			Goods
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			this.getBrand(this.$route.query.id);
			this.change(1);
			console.log(this.searchBarFixed)
		},
		// created() {

		// },
		methods: {
			//品牌详情
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				var offsetTop = document.querySelector('#searchBar').offsetTop - document.documentElement.clientHeight
				if (scrollTop > offsetTop) {
					this.searchBarFixed = true
				} else {
					this.searchBarFixed = false
				}
			},
			getBrand(id) {
				var that = this;
				that.$axios.post(baseUrl + '/mobile/Brand/brandInfo', {
					id: id,
				}).then(function(res) {
					if (res.data.code == 2) {
						that.brand = res.data.data;
					}
				}).catch(function(err) {
					console.log(err);
				});
			},
			getData(id, cat_id) {
				var that = this;
				//线下体验店
				that.$axios.post(baseUrl + '/mobile/Brand/experience', {
					id: id,
					cat_id: cat_id
				}).then(function(res) {
					if (res.data.code == 2) {
						that.localList = res.data.data;
					}
				}).catch(function(err) {
					console.log(err);
				});
			},
			// 调用拨号功能
			callPhone(phoneNumber) {
				window.location.href = 'tel://' + phoneNumber
			},
			//切换
			change(name) {
				this.getData(this.$route.query.id, name);
			}
		}
	}
</script>

<style scoped>
	@import 'brandDetail.css';

	.active>>>.dropdown {
		width: 100%;
		background: #fff;
		z-index: 666;
		position: fixed !important;
		top: 4rem;
		left: 0px;
	}

	.active>>>.dropdown>div {
		width: 25%;
	}

	.brandDetail .active {
		border-bottom: none !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/brandDetail/brandDetail.vue